export const STATE_NAME = 'guruRecommendations'

export const contextKey = (contextType, contextId) => `${contextType}:${contextId}`

export const initialContextState = () => ({
  items: [],
  badge: { tier: null, count: 0 },
  loading: false,
  error: null,
  fetchedAt: null,
})

export const initialState = {
  byContext: {},
  dismissals: {},
}
